import React from "react";
import ComingSoon from "../../components/ComingSoon";

const ESGDocuments = () => {
  return (
    <ComingSoon
      title="ESG Documents"
      description="Manage all your ESG-related documents including policies, compliance documents, and evidence files."
      icon="📋"
    />
  );
};

export default ESGDocuments; 